<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconFullscreenOn_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M8.98 1.005h5.5c.285 0 .515.23.514.515v5.5a.515.515 0 0 1-1.003.164l-.946-2.815-2.858 2.858a.999.999 0 1 1-1.414-1.414l2.858-2.859-2.815-.946a.515.515 0 0 1 .164-1.003M4.369 13.046l2.815.946a.515.515 0 0 1-.164 1.003h-5.5a.514.514 0 0 1-.515-.515v-5.5a.515.515 0 0 1 1.003-.164l.947 2.816 2.858-2.858a.999.999 0 1 1 1.414 1.414z"
        clip-rule="evenodd"
    />
</svg>
